import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { SelectFilterCreator } from '@dreryk/react-components';

export const practitionerSelectFilter: SelectFilterCreator<AppointmentPractitioner> = ({ includes }) => (
   practitioner
) => {
   return includes(practitioner.firstName.asString()) || includes(practitioner.lastName.asString());
};
